import React from 'react';
import clsx from 'clsx';
import styles from './ModalActions.module.scss';

const ModalActions = ({ children = null, className = null, classes = {} }) => {
  return <div className={clsx(styles.root, className, classes.root)}>{children}</div>;
};

export default ModalActions;
